import React from 'react';
import { TabPanel } from '@one-thd/sui-atomic-components';
import { number } from 'prop-types';
import { quotesPropType } from '../../utils/propTypes';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../constants/responsiveClassNames';

const QuotesTabPanels = ({ activeQuotes, expiredQuotes, maxListSize }) => (
  <div className="sui-pt-3 @sm:sui-pt-4">
    <TabPanel value="active" index={0}>
      <div className={showBelowSmBreakpoint}>
        <QuotesCompactList quotes={activeQuotes} maxListSize={maxListSize} />
      </div>
      <div className={showAboveSmBreakpoint}>
        <QuotesCarousel quotes={activeQuotes} />
      </div>
    </TabPanel>
    <TabPanel value="expired" index={1}>
      <div className={showBelowSmBreakpoint}>
        <QuotesCompactList quotes={expiredQuotes} maxListSize={maxListSize} />
      </div>
      <div className={showAboveSmBreakpoint}>
        <QuotesCarousel quotes={expiredQuotes} />
      </div>
    </TabPanel>
  </div>
);

QuotesTabPanels.propTypes = {
  activeQuotes: quotesPropType,
  expiredQuotes: quotesPropType,
  maxListSize: number,
};

QuotesTabPanels.defaultProps = {
  activeQuotes: [],
  expiredQuotes: [],
  maxListSize: 3,
};

export default QuotesTabPanels;